import { SpinnerService } from './../../services/spinner.service';
import { Component } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html'
})
export class SpinnerComponent {

  constructor(private readonly spinnerService: SpinnerService) { }

  public get spinner() {
    return this.spinnerService.spinner;
  }

  public get imgSrc() {
    let src;
    if (localStorage.getItem("customStyles")) {
      const newCustomStyles = JSON.parse(localStorage.getItem("customStyles"));
      if (newCustomStyles.spinnerLogo?.src) {
        src = newCustomStyles.spinnerLogo.src;
      } else {
        src = '/assets/img/logo_gesvatec.png';
      }
    } else {
      src = '/assets/img/logo_gesvatec.png';
    }
    return src;
  }
}
